/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
import { BaseModal } from "newcar-ui/output/es/components/AskpricePublicModal";
import { SelectBLP } from "newcar-ui/output/cjs/components/SelectBLP";
import { tools } from "newcar-ui/output/es/utils";
// 引入 ECharts 主模块
import * as echarts from "echarts/lib/echarts";
// 引入柱状图
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";
import "echarts/lib/component/markLine";
import "echarts/lib/component/markPoint";
window.localList = [];
window.echartsEle = null;
window.firstAction = true;
/** 查成交价 */
const TopSlotFinalPriceNode = React.memo((props) => {
  return (
    <div className="top-slot-node-finalPrice">
      <div className="modal-subtitle">
        近期购车车主上传真实购车发票中的裸车价格
      </div>
      <div className="finalPrice">
        <div className="finalPrice-top">
          ￥{props.finalPriceInfo.finalPriceText || "*.03万"}
        </div>
        <div className="finalPrice-bottom">
          <div className="finalPrice-icon">
            <div className="icon1"></div>
            <div className="icon2"></div>
            <div className="icon3"></div>
            <div className="icon4"></div>
            <div className="icon5"></div>
          </div>
          <div className="finalPrice-text">
            已有<span>{props.finalPriceInfo.proOrderNum || 6241}</span>人获取真实成交价格
          </div>
        </div>
      </div>
    </div>
  );
});
/* 经销商 || 折线图 选择模块*/
const TopSlotPriceEchatsNode = React.memo((props) => {
  const hasChart = props.chatsData.hasChart;
  return (
    <div className="top-slot-node-echats">
      {hasChart == 1 && <div className="echats-title">本地经销商历史报价</div>}
      <div className="modal-subtitle" style={{ lineHeight: hasChart == 1 ? '0.2rem' : '0.3rem' }}>
        <div className="subtitle-text" style={{ fontSize: hasChart == 1 ? '0.12rem' : '0.14rem' }}>
          {hasChart == 1
            ? props.chatsData.productName
            : (props.titleType == 'icon' ? "拨打本地经销商，免费预约试驾" : "拨打本地经销商电话，咨询当日最新报价")}
        </div>
        {hasChart == 1 && (
          <div
            className="change"
            onClick={() => props.callBack && props.callBack()}
          >
            换一款
          </div>
        )}
      </div>
    </div>
  );
});
/* 预约标题*/ 
const TopSlot = React.memo((props) => {
  return (
    <div className="top-slot-node-echats">
      <div className="echats-title">{props.hasDealer ? '免费预约试驾' : (props.checkProductId == -1 ? '获取最新成交价' : '暂无经销商历史报价')}</div>
      <div className="modal-subtitle" >
        <div className="subtitle-text" >
        {props.hasDealer ? '提交您的电话，工作人员立刻为您进行预约' : (props.checkProductId == -1 ? '提交您的电话，咨询最新的成交价信息' : '提交您的电话，顾问立即回电告知您今日报价')} 
        </div>
      </div>
    </div>
  );
});
/*  折线图或者经销商模块   props.chatsData.hasChart 1:折线图 2:经销商*/
const MidSlotNodeEchatsNode = React.memo((props) => {
  useEffect(() => {
    // 如果最低价大于指导价调整图表提示位置
    if (props.chatsData.hasChart == 1) {
      if(props.chatsData.chat.pos.length < 3){
        window.echartsEle && window.echartsEle.dispose();
        window.echartsEle = null;
        return
      }
      let x = [], // x轴标签
        x1 = [], // x轴数据
        y = [], // y数据
        y1 = [], // y轴标签
        min = null, // 最低价
        minNumber = null,
        max = null, // 刻度最大
        index = 0; //  最低价索引
      const chats = props.chatsData.chat;
      
      for (let i = 0; i < chats.pos.length; i++) {
        if (i < chats.pos.length - 1) {
          if (i == 0) {
            min = chats.pos[0].y;
            max = chats.pos[0].y;
          } else {
            // eslint-disable-line
            if(chats.pos[i].y <= min){
              min = chats.pos[i].y;
              index = i;
            }
            max = chats.pos[i].y > max ? chats.pos[i].y : max;
            
          }
          y.push(chats.pos[i].y);
        }
        x.push(chats.x[i].name);
        x1.push(chats.x[i].value);
        if(i == chats.pos.length - 2){
          y1.push(chats.pos[chats.pos.length - 2].y,)
        }else if(i == chats.pos.length - 1){
          y1.push(chats.pos[chats.pos.length - 1].y,)
        }else{
          y1.push(null)
        }
       
      }
      let flag = min == chats.pos[chats.pos.length - 2].y
      max = max > chats.showPrice.value ? max : chats.showPrice.value;
      minNumber = flag ? min - (min - chats.pos[chats.pos.length - 1].y) * 2 : max - (max - min) * 2
      window.echartsEle = echarts.init(document.getElementById("echats"));
      window.echartsEle.setOption({
        color: "#FF582F",
        grid: {
          left: 10,
          right: 30,
          top: 30,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: x1,
          axisLine: { lineStyle: { color: "#fff" } },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: function (value, index) {
              return x.length - 1 == index ? "#FD572F" : "#777777";
            },
            fontSize: 10,
            formatter: function (value, index) {
              return x[index];
            }
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: false,
          axisLine: { lineStyle: { color: "#fff" } },
          axisTick: {
            show: false
          },
          min: minNumber,
          max: max,
          splitLine: { show: false },

          // 最小的值
          axisLabel: {
            color: "#777777",
            fontSize: 10,
            formatter: function (value) {
              return (value / 10000).toFixed(2) + "万";
            }
          }
        },
        series: [
          {
            type: "line",
            markPoint: {
              data: [{ coord: [index, min] }],
              symbol:
                "image://https://wos4.58cdn.com.cn/iJPFeDcBaiYP/fhlbusiness/87vn22g6.png",
              symbolSize: [82, 30],
              symbolOffset: [0, -15],
              label: {
                show: true,
                // position:'inside',
                fontWeight: "normal",
                fontStyle: "normal",
                color: "#fff",
                // width:112.5,
                // lineHeight: 30,
                fontSize: 8,
                padding: [0, 2, 6, 2],
                // borderRadius:20,
                formatter: function () {
                  const { lowPrice } = chats.pos[index].tips;
                  return `最低报价:${lowPrice}`;
                }
              }
            },
            markLine: {
              symbol: "none",
              show: true,
              data: [{ yAxis: chats.showPrice.value }],
              label: {
                show: true,
                position: "middle",
                distance: '5',
                color: "#2C2C2C",
                fontSize: "10",
                formatter: function (params) {
                  return "指导价:" + (params.value / 10000).toFixed(2) + "万";
                }
              },
              lineStyle: {
                normal: {
                  color: "#2C2C2C"
                }
              }
            },
            smooth: true,
            symbol: "none",
            data: y,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255, 243, 230, 1) " // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(253, 226, 201, 0)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            type: "line",
            data: y1,
            symbol: "none",
            smooth: true,
            lineStyle: { type: "dotted", cap: "butt" },
            connectNulls: false
          }
        ]
      });
    } else {
      window.echartsEle && window.echartsEle.dispose();
      window.echartsEle = null;
    }
  }, [props]);
  return (
    <div className="mid-slot-node">
      {props.chatsData.hasChart == 0 ? (
        <div className="dealer-list" id="dealer">
          {props.chatsData.dealer.length > 0 &&
            props.chatsData.dealer.map((item, index) => {
              return (
                <div className="dealer-item" key={index}>
                  <div className="item-left">
                    <div className="item-left-top">{item.dealerFullName}</div>
                    <div className="item-left-bottom">{item.dealerAddress}</div>
                  </div>
                  <div
                    className="item-right"
                    onClick={() => props.callDealer(item.dealerId)}
                  ></div>
                </div>
              );
            })}
        </div>
      ) : (
        props.chatsData.chat && props.chatsData.chat.pos.length > 2 ? <div className="charts">
          <div id="echats"></div>
        </div> : <div className="no-data">
          <div className="no-data-pic"></div>
          <div className="no-data-text">当前车型刚刚上市，报价信息不全</div>
        </div>
      )}
    </div>
  );
});

const Index = () => {
  /** 车型信息 */
  const [chatsData, setChatsData] = useState({});
  const [fCode, setFCode] = useState("");
  const [finalPriceInfo, setFinalPriceInfo] = useState({});
  // 1 查成交价  2 经销商
  const [type, setType] = useState(1);
   // 有没有经销商
   const [hasDealer, setHasDealer] = useState(false);
    // 有没有经销商
    const [titleType, setTitleType] = useState('');
  // 1 查成交价  2 经销商
  const [eventId, setEventId] = useState("147");
  // 是展示城市
  const [cityShow, setCityShow] = useState(true);
  const [bannedDisplayModule, setBannedDisplayModule] = useState(["name"]);
  // 是否展示选择车型弹窗
  const [popShow, setPopShow] = useState(false);
  // 车系ID
  const [lineId, setLineId] = useState("3597");
  // 车系ID
  const [productId, setProductId] = useState("");
  // 车系ID
  const [checkProductId, setCheckProductId] = useState("");
  // 车系ID
  const [defaultProId, setDefaultProId] = useState("");
  /* 经销商控制滑动 */
  // eslint-disable-line
  const [autoScrollId, setAutoScrollId] = useState("dealer");
  /** 城市信息 */
  const [cityInfo, setCityInfo] = useState({
    cid: "",
    name: ""
  });
  /** 查成交价弹窗显示 */
  const [showFinalPriceModal, setShowFinalPriceModal] = useState(false);
  const changeClick = useCallback(() => {
    setPopShow(true);
  }, []);
  const selectedCityFn = useCallback((cityInfo) => {
    setCityInfo(cityInfo);
    localStorage.setItem('seoCarlineAll_cityInfo', JSON.stringify(cityInfo))
  }, []);
  /* 切换车型后的数据处理      */
  const changeCarTypeClick = useCallback(
    (info) => {
      if(!info){
        setPopShow(false);
        return
      }
      tools
        .request(
          "//service.58che.com/unify/v1/dealerPriceChart/",
          {
            lineId: lineId || "2421",
            cityId: cityInfo.cityid || cityInfo.cid,
            productId: info.productId,
            defaultProId: defaultProId || ""
          },
          "jsonp",
          { method: "get" }
        )
        .then(
          (res) => {
            if (res.code == 0) {
              setProductId(res.entity.data.productId);
              setChatsData(res.entity.data);
              if (res.entity.data.hasChart == 0) {
                setBannedDisplayModule([
                  "name",
                  "tel",
                  "code",
                  "submit",
                  "privacy"
                ]);
              } else if (res.entity.data.hasChart == 1) {
                setBannedDisplayModule(["name"]);
              }
            } else {
              console.log("数据错误");
            }
            setPopShow(false);
          },
          (error) => {
            console.log("error:", error);
            setPopShow(false);
          }
        );
    },
    [cityInfo, lineId, defaultProId]
  );
  useEffect(() => {
    window.showLineModalAskPriceAll = onShowFinalPriceModal;
  }, []);
  /** 显示查成交价弹窗 */
  const onShowFinalPriceModal = useCallback(
    (
      from = "",
      lineId = "",
      productId = "",
      type = 2,
      eventId = "",
      defaultProId = "",
      subType = 0,
      titleType = ""
    ) => {

      // 预约试驾 经销商 文案
      setTitleType(titleType);
      /* 区分不同弹窗类型 */
      setDefaultProId(defaultProId);
      setType(type);
      /* 设置车系 */
      setLineId(lineId);
      productId ? setProductId(productId) : setProductId('');
      setEventId(eventId);
      from && setFCode(from);
      let requestURL;
      if (type == 1) {
        requestURL = "//service.58che.com/unify/v1/popup/";
        setBannedDisplayModule(["name"]);
      } else if (type == 2) {
        requestURL = "//service.58che.com/unify/v1/dealerPriceChart/";
        setBannedDisplayModule(["name"]);
      }else{
        setBannedDisplayModule(["name"]);
      }
      window.getCity = window.getCity || window.che.getCity;
      let cityInfo_ = JSON.parse(localStorage.getItem('seoCarlineAll_cityInfo'))
      if(!window.firstAction && cityInfo_ && cityInfo_.name){
        if (productId == "-1") {
          tools
            .request(
              // "//" + location.hostname + "/home.php",
              "//m.58che.com/home.php",
              {
                c: "ajax_Nline",
                a: "GetLineFinalPriceProId",
                cityId: cityInfo_.cid,
                lineId: lineId || "",
              },
              "jsonp",
              { method: "get" }
            ).then((res) => {
              let requestURL;
              if (res.productId == 0) {
                setCheckProductId(-1)
                setType(3);
                type = 3;
                setBannedDisplayModule(["name"]);
                setCityShow(true);
                setShowFinalPriceModal(true);
              } else {
                setType(1);
                type = 1;
                setProductId(res.productId)
                requestURL = "//service.58che.com/unify/v1/popup/";
                setBannedDisplayModule(["name"]);
                tools
                  .request(
                    requestURL,
                    {
                      productId: res.productId || "",
                      lineId: lineId || "2421",
                      cityId: cityInfo_.cid,
                      defaultProId: defaultProId || "",
                      subType: subType
                    },
                    "jsonp",
                    { method: "get" }
                  )
                  .then(
                    (res) => {
                      if (res.code == 0) {
                        if (type == 1) {
                          setFinalPriceInfo(res.entity.data);
                          setCityShow(true);
                        } else if (type == 2) {
                          
                          setProductId(res.entity.data.productId);
                          setChatsData(res.entity.data);
                          if (res.entity.data.hasChart == 0) {
                            if (res.entity.data.dealer.length == 0) {
                              setType(3);
                              setCityShow(true);
                              setShowFinalPriceModal(true);
                              return
                            }
                            setHasDealer(true);
                            setCityShow(false);
                            setBannedDisplayModule([
                              "name",
                              "tel",
                              "code",
                              "submit",
                              "privacy"
                            ]);
                          } else {
                            setCityShow(true)
                          }
                        }
                        setShowFinalPriceModal(true);
                      } else {
                      }
                    },
                    (error) => {
                      console.log("error:", error);
                    }
                  );
              }
            })

        } else {
          if (type == 3) {
            setHasDealer(true);
            setCityShow(true);
            setShowFinalPriceModal(true);
            return
          }
          tools
            .request(
              requestURL,
              {
                productId: productId || "",
                lineId: lineId || "2421",
                cityId: cityInfo_.cid,
                defaultProId: defaultProId || "",
                subType: subType
              },
              "jsonp",
              { method: "get" }
            )
            .then(
              (res) => {
                if (res.code == 0) {
                  if (type == 1) {
                    setFinalPriceInfo(res.entity.data);
                    setCityShow(true);
                  } else if (type == 2) {
                    
                    setProductId(res.entity.data.productId);
                    setChatsData(res.entity.data);
                    if (res.entity.data.hasChart == 0) {
                      if (res.entity.data.dealer.length == 0) {
                        setType(3);
                        setCityShow(true);
                        
                        setShowFinalPriceModal(true);
                        return
                      }
                      setHasDealer(true);
                      setCityShow(false);
                      setBannedDisplayModule([
                        "name",
                        "tel",
                        "code",
                        "submit",
                        "privacy"
                      ]);
                    } else {
                      setCityShow(true)
                    }
                  }
                  setShowFinalPriceModal(true);
                } else {
                }
              },
              (error) => {
                console.log("error:", error);
              }
            );
        }

      }else{
        window.getCity((cityInfo) => {
          // 判断车型id
          localStorage.setItem('seoCarlineAll_cityInfo', JSON.stringify({ cid: cityInfo.cityid, name: cityInfo.name }))
          setCityInfo({ cid: cityInfo.cityid, name: cityInfo.name });
          window.firstAction = false;
          if (productId == "-1") {
            tools
              .request(
               // "//" + location.hostname + "/home.php",
              "//m.58che.com/home.php",
                {
                  c: "ajax_Nline",
                  a: "GetLineFinalPriceProId",
                  cityId: cityInfo.cityid,
                  lineId: lineId || "",
                },
                "jsonp",
                { method: "get" }
              ).then((res) => {
                let requestURL;
                // if (type == 1) {
                //   requestURL = "//service.58che.com/unify/v1/popup/";
                //   setBannedDisplayModule(["name"]);
                // } else if (type == 2) {
                //   requestURL = "//service.58che.com/unify/v1/dealerPriceChart/";
                //   setBannedDisplayModule(["name"]);
                // }else{
                //   setBannedDisplayModule(["name"]);
                // }
                if (res.productId == 0) {
                  setCheckProductId(-1)
                  setType(3);
                  type = 3;
                  setBannedDisplayModule(["name"]);
                  setCityShow(true);
                  setShowFinalPriceModal(true);
                } else {
                  setType(1);
                  type = 1;
                  setProductId(res.productId)
                  requestURL = "//service.58che.com/unify/v1/popup/";
                  setBannedDisplayModule(["name"]);
                  tools
                    .request(
                      requestURL,
                      {
                        productId: res.productId || "",
                        lineId: lineId || "2421",
                        cityId: cityInfo.cityid,
                        defaultProId: defaultProId || "",
                        subType: subType
                      },
                      "jsonp",
                      { method: "get" }
                    )
                    .then(
                      (res) => {
                        if (res.code == 0) {
                          if (type == 1) {
                            setFinalPriceInfo(res.entity.data);
                            setCityShow(true);
                          } else if (type == 2) {
                            setProductId(res.entity.data.productId);
                            setChatsData(res.entity.data);
                            if (res.entity.data.hasChart == 0) {
                              if (res.entity.data.dealer.length == 0) {
                                setType(3);
                                setCityShow(true);
                                setShowFinalPriceModal(true);
                                return
                              }
                              setHasDealer(true);
                              setCityShow(false);
                              setBannedDisplayModule([
                                "name",
                                "tel",
                                "code",
                                "submit",
                                "privacy"
                              ]);
                            } else {
                              setCityShow(true)
                            }
                          }
                          setShowFinalPriceModal(true);
                        } else {
                        }
                      },
                      (error) => {
                        console.log("error:", error);
                      }
                    );
                }
              })

          } else {

            
            if (type == 3) {
              setHasDealer(true);
              setCityShow(true);
              setShowFinalPriceModal(true);
              return
            }
            tools
              .request(
                requestURL,
                {
                  productId: productId || "",
                  lineId: lineId || "2421",
                  cityId: cityInfo.cityid,
                  defaultProId: defaultProId || "",
                  subType: subType
                },
                "jsonp",
                { method: "get" }
              )
              .then(
                (res) => {
                  if (res.code == 0) {
                    if (type == 1) {
                      setFinalPriceInfo(res.entity.data);
                      setCityShow(true);
                    } else if (type == 2) {
                      
                      setProductId(res.entity.data.productId);
                      setChatsData(res.entity.data);
                      if (res.entity.data.hasChart == 0) {
                        if (res.entity.data.dealer.length == 0) {
                          setType(3);
                          setCityShow(true);
                          setShowFinalPriceModal(true);
                          return
                        }
                        setHasDealer(true);
                        setCityShow(false);
                        setBannedDisplayModule([
                          "name",
                          "tel",
                          "code",
                          "submit",
                          "privacy"
                        ]);
                      } else {
                        setCityShow(true)
                      }
                    }
                    setShowFinalPriceModal(true);
                  } else {
                  }
                },
                (error) => {
                  console.log("error:", error);
                }
              );
          }

        });
      }
      
    },
    [cityInfo]
  );
  const onCloseFinalPriceModal = useCallback(() => {
    setShowFinalPriceModal(false);
  }, []);
  const onSubmitCheckedFn = useCallback(
    (info) => {
      tools.sendClickStatistics_wmda(eventId, {
        actiontype: "click",
        pagetype: "prd",
        page: "line-index",
        from_code: tools.getCookie("from") || "",
        cateid: "4,398038",
        reffer: document.referrer,
        url: window.location.href,
        line_id: info.lineId || "",
        product_id: info.productId || ""
      });
    },
    [eventId]
  );
  const onSubmitSuccessFn = useCallback(
    (formdata, result) => {
      setShowFinalPriceModal(false);
      return new Promise(function(resolve, reject){
        window.location.href = '//' + window.location.hostname + '/light/afterapply/index/?orderId=' + result.entity.data.orderId;
        reject('jump');
      })
      
    },
    []
  );
  
  // 拨打电话
  const callDealer = useCallback(
    (dealerId) => {
      const params = {
        dealerId: dealerId,
        lineId: lineId,
        platform: "m",
        uuId: tools.getCookie("58tj_uuid"),
        windowPop: 0,
        linkFrom: tools.getCookie("from_code"),
        source58: null,
        type: "",
        isFrom: fCode || 681
      };
      tools.sendClickStatistics_wmda(214, {
        actiontype: "click",
        pagetype: "prd",
        page: "line-index",
        from_code: tools.getCookie("from") || "",
        cateid: "4,398038",
        reffer: document.referrer,
        url: window.location.href,
        line_id: lineId || "",
        // fCode: fCode || ""
      });
      tools
        .request(
          "//service.58che.com/internal/v1/dealercall/",
          params,
          "jsonp",
          { method: "get" }
        )
        .then(
          (res) => {
            if (res.code == 0 && res.entity.data && res.entity.data.tel) {
              window.location = "tel:" + res.entity.data.tel;
            } else {
              alert("接口繁忙，请您稍后再试！");
            }
          },
          (error) => {
            console.log("error:", error);
          }
        );
    },
    [lineId, fCode]
  );
  return (
    <div>
      <SelectBLP
        show={popShow}
        lineId={lineId}
        closeFun={changeCarTypeClick}
        callbackFun={changeCarTypeClick}
        level={"P"}
      ></SelectBLP>
      <BaseModal
        visible={showFinalPriceModal}
        bannedDisplayModule={bannedDisplayModule}
        autoScrollId={autoScrollId}
        topSlotNode={
          type == 1 ? (
            <TopSlotFinalPriceNode finalPriceInfo={finalPriceInfo} />
          ) : (type == 2 ?
            <TopSlotPriceEchatsNode
              chatsData={chatsData}
              titleType={titleType}
              callBack={changeClick}
            /> : <TopSlot hasDealer={hasDealer} checkProductId={checkProductId}/>
          )
        }
        midSlotNode={
          type == 1 || type == 3 ? null : (
            <MidSlotNodeEchatsNode
              chatsData={chatsData}
              callDealer={callDealer}
            />
          )
        }
        closeFun={onCloseFinalPriceModal}
        fCode={fCode}
        prodInfoRelate={{
          showProdArea: false,
          productId: productId,
          lineId: lineId
        }}
        titleRelate={{
          mainTitleShow: false,
          btnMainTitle: type == 1 ? "立即询价" : "立即咨询",
          btnBotTitle:
            type == 1
              ? "提交可查看完整最低成交价"
              : "提交后专业顾问24小时内为您提供今日最新报价"
        }}
        contentCn={"linecars"}
        modalCn="newcar-modal-wrap"
        // messageCodeRelate={{needMsgCode:0}}
        cityinfoRelate={{
          show: cityShow,
          selectedCityFn: selectedCityFn,
          defaultCityInfo: {
            cityid: cityInfo.cid,
            cityname: cityInfo.name
          }
        }}
        submitRelate={{ onSubmitCheckedFn: onSubmitCheckedFn,
          onSubmitSuccessFn: onSubmitSuccessFn
         }}
      />
    </div>
  );
};

export default Index;
